import {
  Injectable,
} from '@angular/core';
import {DeviceSettingsRepository} from 'webcommon/legacy-common';

import {DefaultDocumentHelper} from './DefaultDocumentHelper';
import {IosDocumentHelper} from './IosDocumentHelper';
import {WebDocumentHelper} from './WebDocumentHelper';

import {DocumentHelper} from 'webcommon/shared';

import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DocumentHelperBase implements DocumentHelper {
  private get innerHelper(): DocumentHelper {
    if (this.deviceSettingsRepository.isIos) {
      return this.iosDocumentHelper;
    } else if (this.deviceSettingsRepository.isStandaloneBrowser) {
      return this.webDocumentHelper;
    } else {
      return this.defaultDocumentHelper;
    }
  }

  constructor(
    private readonly deviceSettingsRepository: DeviceSettingsRepository,
    private readonly iosDocumentHelper: IosDocumentHelper,
    private readonly webDocumentHelper: WebDocumentHelper,
    private readonly defaultDocumentHelper: DefaultDocumentHelper,
  ) {
  }

  openUrlInSeparateTab(url$: Observable<string>) {
    this.innerHelper.openUrlInSeparateTab(url$);
  }

  supportsOpenInSeparateTab(): boolean {
    return this.innerHelper.supportsOpenInSeparateTab();
  }
}
